<template>
    <span>{{ displayNumberFormatted }}</span>
</template>

<script>
export default {
    name: "AnimatedNumber",
    props: {
        number: {
            type: Number,
            default: 0
        },
        duration: {
            type: Number,
            default: 50
        },
        delay: Number
    },
    data() {
        return {
            displayNumber: this.number ?? 0,
            interval: null
        }
    },
    computed: {
        difference() {
            return this.number - this.displayNumber;
        },
        displayNumberFormatted() {
            return Math.round(this.displayNumber);
        }
    },
    watch: {
        async number(newValue, oldValue) {
            setTimeout(() => {
                this.animate();
            }, this.delay);
        }
    },
    methods: {
        animate() {
            if (this.number === this.displayNumber) return;

            const difference = this.number - this.displayNumber;
            const interval =  Math.abs(Math.floor(this.duration / difference));

            // Get current time and set end time
            const startTime = new Date().getTime();
            const endTime = startTime + this.duration;

            const step = () => {
                const now = new Date().getTime();
                const remaining = Math.max((endTime - now) / this.duration, 0);
                const value = Math.round(this.number - (remaining * difference));

                this.displayNumber = value;

                if (this.displayNumber === this.number) clearInterval(timer);
            };

            const timer = setInterval(step, interval);
            step();
        }
    }
}
</script>

<style scoped>

</style>
